<template>
  <a-drawer title="优惠券用户列表" :visible="visible" :width="1000" @close="close" destroyOnClose>
    <a-form layout="inline" labelAlign="right">
      <a-form-item label="手机号">
        <a-input v-model="queryParam.userMobile" placeholder="请输入" allow-clear />
      </a-form-item>

      <a-form-item label="状态">
        <a-select v-model="queryParam.status" class="small-select">
          <a-select-option :value="null">全部</a-select-option>
          <a-select-option :value="0">失效</a-select-option>
          <a-select-option :value="1">有效</a-select-option>
          <a-select-option :value="2">已使用</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="领券时间">
        <a-range-picker v-model="dateRange" format="YYYY-MM-DD" @change="onDateChange" />
      </a-form-item>

      <a-form-item class="btn-group">
        <a-button type="primary" @click="handleQuery">查询</a-button>
        <a-button style="margin-left: 8px" @click="resetQuery">重置</a-button>
      </a-form-item>
    </a-form>

    <a-table
      class="data-table"
      row-key="id"
      :columns="columns"
      :data-source="list"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <span slot="couponType" slot-scope="text">{{ { 10: '代金券', 20: '折扣券', 30: '免单券' }[text] }}</span>
      <span slot="status" slot-scope="text">{{ { 0: '失效', 1: '有效', 2: '已使用' }[text] }}</span>
      <span slot="action" slot-scope="text, record">
        <a v-hasPermi="['share:usercoupon:tj']" @click="handleInfoStat(record)">信息统计</a>
        <a-divider type="vertical" />
        <a v-hasPermi="['coupon:user:edit']" @click="handleStatusEdit(record)">修改状态</a>
        <a-divider type="vertical" />
        <a v-hasPermi="['coupon:user:remove']" @click="handleDelete(record)">删除</a>
      </span>
    </a-table>

    <div class="drawer-footer">
      <a-button @click="close">关闭</a-button>
    </div>
    <UserCouponInfoStatDrawer ref="infoStat" />
  </a-drawer>
</template>

<script>
import { listUserCoupon, deleteUserCoupon, updateUserCoupon } from '@/api/coupon/controller'
import UserCouponInfoStatDrawer from './UserCouponInfoStatDrawer.vue'
export default {
  name: 'CouponUserDrawer',
  components: { UserCouponInfoStatDrawer },
  data() {
    return {
      visible: false,
      couponId: null,
      loading: false,
      list: [],
      dateRange: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        couponId: null,
        userMobile: '',
        status: null,
        createBeginTime: '',
        createEndTime: '',
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
      },
      columns: [
        { title: '用户名称', dataIndex: 'userName', align: 'center', width: 120 },
        { title: '手机号', dataIndex: 'userMobile', align: 'center' },
        { title: '优惠券', dataIndex: 'couponName', align: 'center' },
        { title: '类型', dataIndex: 'couponType', align: 'center', scopedSlots: { customRender: 'couponType' } },
        { title: '状态', dataIndex: 'status', align: 'center', scopedSlots: { customRender: 'status' } },
        { title: '领券时间', dataIndex: 'receiveTime', align: 'center', sorter: true },
        { title: '操作', dataIndex: 'action', align: 'center', scopedSlots: { customRender: 'action' }, width: 240 },
      ],
    }
  },
  methods: {
    handleStatusEdit(row) {
      const that = this

      this.$confirm({
        title: '确认将该用户优惠券置为失效？',
        onOk() {
          return updateUserCoupon({
            id: row.id,
          }).then(() => {
            that.getList()
            that.$message.success('设置成功', 3)
          })
        },
        onCancel() {},
      })
    },
    open(couponId) {
      this.couponId = couponId
      this.queryParam.couponId = couponId
      this.visible = true
      this.getList()
    },
    close() {
      this.visible = false
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        couponId: null,
        userMobile: '',
        status: null,
        createBeginTime: '',
        createEndTime: '',
      }
      this.dateRange = []
    },
    getList() {
      this.loading = true
      listUserCoupon(this.queryParam).then((res) => {
        const { records, total } = res.data
        this.list = records
        this.pagination.total = total
        this.pagination.current = this.queryParam.pageNum
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam.pageNum = 1
      this.queryParam.userMobile = ''
      this.queryParam.status = null
      this.queryParam.createBeginTime = ''
      this.queryParam.createEndTime = ''
      this.dateRange = []
      this.getList()
    },
    onDateChange(dates) {
      this.queryParam.createBeginTime = dates ? dates[0].format('YYYY-MM-DD 00:00:00') : ''
      this.queryParam.createEndTime = dates ? dates[1].format('YYYY-MM-DD 23:59:59') : ''
    },
    handleTableChange(pagination, filters, sorter) {
      this.queryParam.pageNum = pagination.current
      this.queryParam.pageSize = pagination.pageSize
      this.queryParam.sortField = sorter.columnKey || ''
      this.queryParam.sortOrder = sorter.order === 'ascend' ? 'ASCEND' : sorter.order === 'descend' ? 'DESCEND' : ''
      this.getList()
    },

    handleInfoStat(row) {
      this.$refs.infoStat.open({ userId: row.userId, couponId: row.couponId })
    },
    handleDelete(row) {
      var that = this
      let ids = []
      const postIds = row.id || this.ids
      if (row.id) {
        ids = [{ id: postIds }]
      } else {
        postIds.forEach((v) => {
          ids.push({ id: v })
        })
      }

      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return deleteUserCoupon(ids).then(() => {
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
  },
}
</script>

<style scoped>
.query-form {
  margin-bottom: 16px;
}

.small-select {
  width: 100px;
}

.btn-group {
  margin-left: auto;
  float: right;
}

.data-table {
  margin-top: 16px;
}

.drawer-footer {
  position: absolute;
  right: 16px;
  bottom: 16px;
  width: 100%;
  padding: 10px 16px;
  background: #fff;
  border-top: 1px solid #e9e9e9;
  text-align: right;
}
</style>
